import { useEffect, useState } from "react";
import contentData from './content.json';

const useRefinancePageData = () => {
  const jsonPath = process.env.REACT_APP_CDN_RESOURCE + "swmcrealty2025/realtyPage.json";
  const [refinancePageData, setRefinancePageData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(jsonPath);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const jsonData = await response.json();
        setRefinancePageData(jsonData);
      } catch (err) {
        console.error("Error fetching Refinance JSON from CDN, falling back to local data:", err);
        setRefinancePageData(contentData);
      }
    };

    fetchData();
  }, [jsonPath]);

  return refinancePageData;
};

export default useRefinancePageData;
